import { ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './LandingPanel.module.css';

type Props = {
  children?: ReactNode;
  preset?: 'light' | 'dark';
};

export function LandingPanel({ children, preset = 'light' }: Props) {
  return (
    <div className={cx(styles.root, styles[`preset_${preset}`])}>
      {children}
    </div>
  );
}
